export default {
   namespaced: true,
   state() {
     return {
      companyInfo: {
         trademark: "Vuetify is a Vue UI Library with beautifully handcrafted Material Components. No design skills required — everything you need to create amazing applications is at your fingertips.",
         license: "Everything you need to create amazing applications is at your fingertips."
      },
      paymentMethods: {
         description: "Enjoy a hassle-free deposit and withdrawal experience as our payment methods are fast and secured. We supports major payment methods that are available worldwide!",
         src: require("../../assets/footer/sponsors/paymentMethod.png")
      },
   
      otherUsefulLinks: [
         { label: "About us", path: ""},
         { label: "Affiliates", path: ""},
         { label: "Responsible Gaming", path: ""},
         { label: "Term & Conditions", path: ""},
         { label: "Privacy Policy", path: ""},
         { label: "Sitemap", path: ""},
      ],
      changeRegion: [
         { label: "English",type: "icon", icon:"", path: ""}
      ], 
      needHelpNow: [
         { label: "FAQs", path: ""},
         { label: "Live Chat", path: ""},
         { label: "Contact Us", path: ""},
      ],
      contactPoints: [
         { label: "Phone:", value: "342 543 0987", path: ""},
         { label: "Phone:", value: "32 33 6654 0987", path: ""},
         { label: "Email:", value: "support-en@uxteamservice.com", path: ""},
      ],
      socialMedia: [
         {icon: "mdi-youtube", path: ""},
         {icon: "mdi-facebook", path: ""},
      ],

     }
   },
   getters: {
      companyInfo(state) {
         return state.companyInfo
      },
      otherUsefulLinks(state) {
         return state.otherUsefulLinks
      },
      changeRegion(state) {
         return state.changeRegion
      },
      needHelpNow(state) {
         return state.needHelpNow
      },
      contactPoints(state) {
         return state.contactPoints
      },
      socialMedia(state) {
         return state.socialMedia
      },
      paymentMethods(state) {
         return state.paymentMethods
      },
   },
 }
 